export default function PHP_move_uploaded_file() {
  return (
    <div>
      <h1>PHP_move_uploaded_file</h1>
    </div>
  );
}
